export default ({ matrix }) => ({
    /* -----------------------------
     * STATE
     * --------------------------- */
    matrix: matrix ?? {},

    selectedColor: null,
    selectedSize: null,
    quantity: 1,
    showSticky: false,
    adding: false,

    /* -----------------------------
     * INIT
     * --------------------------- */
    init() {
        this.normalizeMatrix();
        this.initOffer();
        this.observePurchasePanel();
    },

    normalizeMatrix() {
        if (!this.matrix || typeof this.matrix !== 'object') {
            this.matrix = {};
            return;
        }

        const firstKey = Object.keys(this.matrix)[0];
        if (!firstKey) return;

        const firstValue = this.matrix[firstKey];
        if (firstValue && firstValue.offer_id) {
            this.matrix = {
                0: this.matrix,
            };
        }
    },

    initOffer() {
        const colors = Object.keys(this.matrix);

        if (!colors.length) {
            this.selectedColor = null;
            this.selectedSize = null;
            return;
        }

        this.selectedColor = Number(colors[0]);

        const sizes = Object.keys(this.matrix[this.selectedColor] ?? {});
        this.selectedSize = sizes.length ? Number(sizes[0]) : null;
    },

    /* -----------------------------
     * STICKY PANEL
     * --------------------------- */
    observePurchasePanel() {
        if (!this.$refs.purchasePanel) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                this.showSticky = !entry.isIntersecting;
            },
            { rootMargin: '-80px' }
        );

        observer.observe(this.$refs.purchasePanel);
    },

    /* -----------------------------
     * SELECTORS
     * --------------------------- */
    selectColor(id) {
        if (!this.matrix[id]) return;

        this.selectedColor = id;

        const sizes = Object.keys(this.matrix[id]);
        this.selectedSize = sizes.length ? Number(sizes[0]) : null;
    },

    selectSize(id) {
        if (!this.isSizeAvailable(id)) return;
        this.selectedSize = id;
    },

    isSizeAvailable(id) {
        return !!this.matrix?.[this.selectedColor]?.[id];
    },

    /* -----------------------------
     * COMPUTED
     * --------------------------- */
    get offer() {
        if (this.selectedColor === null || this.selectedSize === null) {
            return null;
        }

        return this.matrix?.[this.selectedColor]?.[this.selectedSize] ?? null;
    },

    get offerId() {
        return this.offer?.offer_id ?? null;
    },

    get article() {
        return this.offer?.article ?? '';
    },

    get basePricePerUnit() {
        return this.offer?.base_price_per_unit ?? null;
    },

    get discountPercent() {
        return this.offer?.discount_percent ?? null;
    },

    get hasDiscount() {
        return Number(this.discountPercent) > 0;
    },

    get pricePerUnit() {
        return this.offer?.price_per_unit ?? 0;
    },

    get packageSize() {
        return this.offer?.package_size ?? 0;
    },

    get packagePrice() {
        return this.pricePerUnit * this.packageSize;
    },

    get oldPackagePrice() {
        return this.basePricePerUnit
            ? this.basePricePerUnit * this.packageSize
            : null;
    },

    get totalWeight() {
        return this.packageSize * this.quantity;
    },

    get sum() {
        return this.packagePrice * this.quantity;
    },

    /* -----------------------------
     * QUANTITY
     * --------------------------- */
    increment() {
        this.quantity++;
    },

    decrement() {
        if (this.quantity > 1) {
            this.quantity--;
        }
    },

    /* -----------------------------
     * CART
     * --------------------------- */
    addToCart() {
        if (!this.offerId || this.quantity < 1 || this.adding) {
            return;
        }

        this.adding = true;

        fetch(Alpine.store('app').routes.cart.add, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': Alpine.store('app').csrf,
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                offer_id: this.offerId,
                quantity: this.quantity,
            }),
        })
            .then(async response => {
                if (!response.ok) {
                    throw await response.json();
                }
                return response.json();
            })
            .then(data => {
                if (data.cart && Alpine.store('cart')) {
                    Alpine.store('cart').sync(data.cart);
                }

                this.onAddedSuccess();
            })
            .catch(error => {
                console.error('Add to cart error:', error);
                this.onAddedError(error);
            })
            .finally(() => {
                this.adding = false;
            });
    },

    /* -----------------------------
     * FEEDBACK
     * --------------------------- */
    onAddedSuccess() {
        // можно добавить toast / анимацию
    },

    onAddedError(error) {
        // обработка ошибок
    },
});
